import React, { useEffect, useState } from 'react'
import TableItems from './Table'
import SearchBar from '../../../utils/searchbar'
import FilterDropdown from './FilterDropdown'
import axiosInstance from '../../../utils/axiosInstance'
import { fetch_roles, fetchAll_users } from '../../shared/ApiEndpoint'
import { useSearchParams } from 'react-router-dom'
import { updateURLFilters } from '../../../utils/updateURLFilters'
import CommonPagination from '../../../utils/Pagination'
import { LIMIT } from '../../shared/Constant'
import EditUserModal from './EditUserModal'
import CreateUserModal from './CreateUserModal'

const UserManagement = () => {
  const [searchParam,setSearchParam]=useSearchParams();
  const initialParam=searchParam.get('keyword')||'';
  const initialPage = searchParam.get('page') || 1;
const initialrole = searchParam.get('role') || 'all';
const [selectedRoleId, setSelectedRoleId] = useState(initialrole);
  const [searchTerm, setSearchTerm] = useState(initialParam);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [show, setShow] = useState(false);
  const [showCreateModal,setShowCreateModal]=useState(false);
  const [user, setUser] = useState([
    {
      id:0,
      userName:"",
      FirstName: "",
      LastName: "",
      role: "",
      email:"",
      rolename:""
    }
  ])
  const [selectedEditUser,setSelectedEditUser]=useState({
    id:0,
    userName:"",
    FirstName: "",
    LastName: "",
    role: "",
    email:"",
    rolename:""
  });
  const [roles, setRoles] = useState([]);



  useEffect(() => {
    fetch_Users(searchTerm,currentPage,selectedRoleId);
    getRoles();
  },[])

   const getRoles = async () => {
      try {
        const response = await axiosInstance.get(fetch_roles, { withCredentials: true });
        if (response?.status === 200) {
          setRoles(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };

  const fetch_Users=async(searchTerm="",currentPage=1,roleId="")=>{
    const offset = (currentPage - 1) * LIMIT;
    const response=await axiosInstance.post(fetchAll_users,{
      limit:LIMIT,
      offset:offset,
      ...(searchTerm && {search:searchTerm }),
     ...(roleId && roleId !== "all" && { role: parseInt(roleId) }),
    }, {withCredentials: true});

    if(response?.status===200){
      const data=response?.data?.users?.map((user,index)=>({
        index: index + 1,
        id:user?.id,
        userName:user?.username,
        FirstName:user?.first_name,
        LastName:user?.last_name,
        role:user?.role,
        email:user?.email,
        rolename:user?.rolename
    }))
      setUser(data);
      setTotal(response?.data?.total)
    }
      
  }

    const handleOnSearch = (string, results) => {
    setSearchTerm(string);
  };

    const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      if (searchTerm.trim() !== "") {
        fetch_Users(searchTerm,currentPage,selectedRoleId);
      }
      if (searchTerm.trim() === "") {
        // setApprovedDeals([]);
        // setPendingDeals([]);
        // setCurrentPage(1);
        fetch_Users(searchTerm,currentPage,selectedRoleId);
      }
      updateURLFilters( searchParam, setSearchParam, { keyword: searchTerm })
    }
  };


    const handlePageChange = (page) => {
    setCurrentPage(page);
    fetch_Users(searchTerm, page,selectedRoleId);
    updateURLFilters(searchParam, setSearchParam, { page: page ? page : null });
    // Fetch new data or update content here
  };

      const handleShow = (item) =>{ 
        setShow(true);
        setSelectedEditUser({
          id:item.id,
          userName:item.userName,
          FirstName:item.FirstName,
          LastName:item.LastName,
          role:item.role,
          email:item.email,
          rolename:item.rolename
        })
      }


  return (
<>
    <div>
         <div className="row align-items-center justify-content-between mb-4">
  {/* SearchBar aligned to left */}
  <div className="col-md-6" onKeyDown={handleKeyDown}>
    <SearchBar
      placeholder="Search Users ..."
      searchTerm={searchTerm}
      handleOnSearch={handleOnSearch}
    />
  </div>

  {/* Create User and Filter aligned to right */}
  <div className="col-md-6 d-flex justify-content-end gap-3">
    <button className="btn btn-primary" onClick={()=>setShowCreateModal(true)}>
      Create User
    </button>
    <FilterDropdown
      setSelectedRoleId={setSelectedRoleId}
      selectedRoleId={selectedRoleId}
      fetch_Users={fetch_Users}
      searchTerm={searchTerm}
      currentPage={currentPage}
      setSearchParam={setSearchParam}
      searchParam={searchParam}
      roles={roles}
    />
  </div>
</div>

     {user && <TableItems data={user} setUser={setUser} handleShow={handleShow}/>}
     {showCreateModal && <CreateUserModal show={showCreateModal} setShow={setShowCreateModal} fetch_Users={fetch_Users} searchTerm={searchTerm} currentPage={currentPage} selectedRoleId={selectedRoleId} roles={roles} />}
     {show && <EditUserModal show={show} setShow={setShow} selectedEditUser={selectedEditUser} setSelectedEditUser={setSelectedEditUser} fetch_Users={fetch_Users} searchTerm={searchTerm} currentPage={currentPage} selectedRoleId={selectedRoleId} roles={roles}/>}
    </div>
   {total>LIMIT &&   <CommonPagination total={total} pageSize={LIMIT} currentPage={currentPage} showSizeChanger={false} onPageChange={handlePageChange}/>}
</>
  )
}

export default UserManagement
